import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
let messages
let language

function loadLocaleMessages () {
    const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
      const matched = key.match(/([A-Za-z0-9-_]+)\./i)
      if (matched && matched.length > 1) {
        const locale = matched[1]
        messages[locale] = locales(key)
      }
    })
    return messages
}

if(process.env.NODE_ENV == 'test'){
  messages = {
    en: require('@/locales/en.json')
  }
}else {
  messages = loadLocaleMessages()
}

if (localStorage.user) {
  language = localStorage.user ? JSON.parse(localStorage.user).language : ''
}

export default new VueI18n({
    locale: language || process.env.VUE_APP_I18N_LOCALE || 'sv', 
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: messages
});

